import tableCellClasses from "@mui/material/TableCell/tableCellClasses";
import { typographyResponsive } from "../../styles/utils";
export const MuiTableCellTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                [`&.${tableCellClasses.root}`]: typographyResponsive(dt, "body1.regular"),
                [`&.${tableCellClasses.head}`]: {
                    color: "#000",
                },
                [`&.${tableCellClasses.body}`]: {
                    color: dt.color.onSurface.key,
                },
                "tbody &[class][class]": {
                    borderTop: `1px solid ${dt.color.surface.variant}`,
                    borderBottomWidth: 0,
                },
                "tbody > tr:last-of-type > &[class][class]": {
                    borderBottom: `1px solid ${dt.color.surface.variant}`,
                },
                padding: `${dt.inset.squish.small.vertical} ${dt.inset.squish.small.horizontal}`,
                [`&.${tableCellClasses.root}:first-of-type`]: {
                    paddingLeft: dt.inline.medium,
                },
                [`&.${tableCellClasses.root}:last-of-type`]: {
                    paddingRight: dt.inline.medium,
                },
            },
        },
    };
};
